enum VatRate {
  ZERO = "zero", // 0
  REDUCED = "reduced", // 6
  INTERMEDIATE = "intermediate", // 12
  STANDARD = "standard" //21
}

export default VatRate;
